// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 5rem;\n  background-color: var(--primary-color);\n  font-size: 1.4rem;\n  color: #f5f5f5;\n  padding: 0 2rem;\n}\n", ""]);
// Exports
module.exports = exports;
